// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

const relatedPropertiesSwiperArray = document.querySelectorAll('.swiper--related-lifestyles')

if (relatedPropertiesSwiperArray) {

  [...relatedPropertiesSwiperArray].forEach((relatedPropertiesSwiper) => {

    console.log(relatedPropertiesSwiper);
    // init Swiper:
    const swiper = new Swiper('.swiper--related-lifestyles', {
      // Optional parameters
      loop: false,
      slidesPerView: 1,
      watchSlidesProgress: true,
      spaceBetween: 20,
      watchOverflow: true,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      breakpoints : {
        768 : {
          slidesPerView: 3,
        },
        1024 : {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },

      // If we need pagination
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },

      // And if we need scrollbar
      scrollbar: {
        el: '.swiper-scrollbar',
      },
    });
  })
}

